export const USER_STATUSES = {
  verified: "✅ Проверенный", vip: "⭐ VIP", premium: "💎 Премиум", new: "🆕 Новичок",
  review: "⚠️ На проверке", blacklist: "🚫 ЧС", blocked: "🔒 Заблокирован",
};
export const ROLE_LABELS = { owner: "👑 Владелец", admin: "🛡️ Администратор", moderator: "🔨 Модератор", user: "👤 Пользователь" };
export const ORDER_FILTERS = [["all", "Все"], ["new", "Новые"], ["in_progress", "В работе"], ["done", "Оказана"], ["rejected", "Отклонённые"], ["overdue", "Просроченные"]];
export const ORDER_STATUS_LABELS = { new: "🆕 Новый", in_progress: "🔨 В работе", done: "✅ Оказана", rejected: "❌ Отклонён" };
export const REVIEW_FILTERS = [["all", "Все"], ["published", "Опубликованные"], ["hidden", "Скрытые"], ["pending", "На проверке"]];
export const REVIEW_STATUS_LABELS = { published: "✅ Опубликован", hidden: "👁 Скрыт", pending: "⏳ На проверке" };
export const LANGS = ["RU", "EN", "CN"];
export const PRIORITIES = { low: "Низкий", normal: "Обычный", high: "Высокий" };
